import React from "react";
import { Field } from "formik";
import PropTypes from "prop-types";
import FormField from "../fields/FormField";
import Label from "../../../atoms/label/Label";
import Tooltip from "../../../atoms/tooltip/Tooltip";

const TextInput = props => {
  const {
    label,
    name,
    wrapperClass,
    classes,
    required,
    tooltip,
    onInputFocus
  } = props;

  return (
    <FormField classes={wrapperClass} name={name}>
      <Label text={label} id={name} required={required} />
      {tooltip && <Tooltip text={tooltip} />}
      <Field
        className={classes}
        type="text"
        name={name}
        id={name}
        onFocus={onInputFocus}
      />
    </FormField>
  );
};

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  wrapperClass: PropTypes.string,
  classes: PropTypes.string,
  required: PropTypes.bool,
  tooltip: PropTypes.string,
  onInputFocus: PropTypes.func
};

TextInput.defaultProps = {
  wrapperClass: "form-item",
  classes: "form-item__textfield",
  required: false,
  tooltip: "",
  onInputFocus: () => {}
};

export default TextInput;
